import dayjs from "dayjs";
import React from "react";

export default function QRScanTable({ qrData }) {
  const table = {
    header: [
      {
        id: 1,
        title: "LOT",
      },
      {
        id: 2,
        title: "QR번호",
      },
      {
        id: 3,
        title: "제조일자",
      },
      {
        id: 4,
        title: "유효일자",
      },
    ],
  };
  return (
    <>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center text-black">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd]"
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="p-3 border border-[#dddddd]">
                {qrData.productLotInfo.lotNo}
              </td>
              <td className="p-3 border border-[#dddddd]">{qrData.qrNo}</td>
              <td className="p-3 border border-[#dddddd]">
                {qrData.productLotInfo.manufacDate
                  ? dayjs(qrData.productLotInfo.manufacDate).format(
                      "YYYY-MM-DD"
                    )
                  : "-"}
              </td>
              <td className="p-3 border border-[#dddddd]">
                {qrData.productLotInfo.expireDate
                  ? dayjs(qrData.productLotInfo.expireDate).format("YYYY-MM-DD")
                  : "-"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
